module.exports = __webpack_public_path__ + "img/eye.0c495d29.svg";